/**
 * Wer Rabbit Fuel betreibt -- die einzige Stelle, an der Impressum und
 * Datenschutzerklaerung ihre Angaben herholen.
 *
 * Alles in [eckigen Klammern] ist ein Platzhalter: die Seiten heben ihn
 * gelb hervor, damit keiner live geht, ohne dass es auffaellt. Felder, die
 * fuer die spaetere Rechtsform nicht gelten, auf `null` setzen -- dann
 * verschwindet die ganze Zeile.
 *
 * Wichtig: Die Texte sind sorgfaeltig fuer genau das geschrieben, was die App
 * heute tut. Sie ersetzen keine Rechtsberatung. Vor dem oeffentlichen Start
 * einmal pruefen lassen -- und bei jeder neuen Funktion, die Daten nach
 * draussen schickt, nachziehen (siehe README, „Impressum und Datenschutz").
 */
export interface Operator {
  /** Name bzw. Firma inkl. Rechtsform, z. B. „Rabbit Fuel GmbH" oder „Max Muster". */
  name: string;
  street: string;
  city: string;
  country: string;
  email: string;
  /** Zweiter schneller Kontaktweg neben der E-Mail. */
  phone: string;
  /** Nur GmbH/UG/Verein: Geschaeftsfuehrung bzw. vertretungsberechtigter Vorstand. */
  representedBy: string | null;
  /** Nur wenn eingetragen: Registergericht und Nummer. */
  register: string | null;
  /** Nur wenn vorhanden. */
  vatId: string | null;
  economicId: string | null;
  /** Verantwortlich fuer journalistisch-redaktionelle Inhalte (§ 18 Abs. 2 MStV). */
  contentResponsible: string;
  /** Datenschutzbeauftragte:r -- nur wenn bestellt, sonst null. */
  privacyOfficer: string | null;
  /** Wo der Server laeuft. */
  hoster: string;
  /** Wie lange Server-Protokolle aufbewahrt werden. */
  logRetention: string;
  /** Wann Chat, Startlisten und Ergebnisse eines beendeten Events geloescht werden. */
  eventRetention: string;
  /** Aufsichtsbehoerde am Sitz des Betreibers. */
  authority: string;
  /**
   * Worauf die Uebermittlung an Twitch (USA, ohne Angemessenheitsbeschluss)
   * gestuetzt wird -- muss rechtlich geklaert werden. Bis dahin lieber nur
   * YouTube anbieten.
   */
  twitchBasis: string;
  /** Stand der Texte. */
  updated: string;
}

export const OPERATOR: Operator = {
  name: '[Name bzw. Firma mit Rechtsform]',
  street: '[Straße und Hausnummer — kein Postfach]',
  city: '[PLZ Ort]',
  country: 'Deutschland',
  email: '[E-Mail-Adresse]',
  phone: '[Telefonnummer]',
  representedBy: '[nur bei GmbH, UG oder Verein: Geschäftsführung bzw. Vorstand — sonst Zeile streichen]',
  register: '[nur falls eingetragen: Registergericht und Nummer, z. B. Amtsgericht Frankfurt am Main, HRB 000000 — sonst Zeile streichen]',
  vatId: '[nur falls vorhanden: DE000000000 — sonst Zeile streichen]',
  economicId: '[nur falls vorhanden: Wirtschafts-Identifikationsnummer — sonst Zeile streichen]',
  contentResponsible: '[Vor- und Nachname, Anschrift wie oben]',
  privacyOfficer: null,
  hoster: '[Name und Anschrift des Hosting-Anbieters]',
  logRetention: '[14 Tage]',
  eventRetention: '[Frist festlegen, z. B. 30 Tage nach Ende des Events]',
  authority:
    '[Datenschutz-Aufsichtsbehörde des Bundeslands, in dem der Betreiber sitzt — z. B. in Hessen: Der Hessische Beauftragte für Datenschutz und Informationsfreiheit, Wiesbaden]',
  twitchBasis: '[Grundlage der Übermittlung an Twitch rechtlich klären und hier nennen]',
  updated: 'Oktober 2026',
};
